@if (sale?.status) {
    @if (sale.status === ISaleStatus.DRAFT) {
        <div class="tw:border-1 tw:rounded-full tw:px-3 tw:py-1 tw:text-center tw:text-xs tw:font-semibold tw:uppercase tw:whitespace-nowrap tw:bg-neutral-100 tw:text-neutral-700">
            {{ 'SALES_STATUS.draft' | translate }}
        </div>
    } @else if (isInvoicingActive() && (sale.invoicingWasActiveAtCreation || sale.invoiceStatus === InvoiceStatus.PARTIALLY_INVOICED)) {
        <div class="tw:border-1 tw:rounded-full tw:px-3 tw:py-1 tw:text-center tw:text-xs tw:font-semibold tw:uppercase tw:whitespace-nowrap"
            [class.tw:bg-success-100]="sale.status === ISaleStatus.PAID && sale.invoiceStatus === InvoiceStatus.INVOICED"
            [class.tw:text-success-800]="sale.status === ISaleStatus.PAID && sale.invoiceStatus === InvoiceStatus.INVOICED"
            [class.tw:bg-error-100]="sale.status === ISaleStatus.PENDING_PAYMENT && sale.invoiceStatus === InvoiceStatus.INVOICED"
            [class.tw:text-error-800]="sale.status === ISaleStatus.PENDING_PAYMENT && sale.invoiceStatus === InvoiceStatus.INVOICED"
            [class.tw:bg-warning-100]="sale.status !== ISaleStatus.CANCELLED && sale.invoiceStatus !== InvoiceStatus.INVOICED"
            [class.tw:text-warning-800]="sale.status !== ISaleStatus.CANCELLED && sale.invoiceStatus !== InvoiceStatus.INVOICED"
            [class.tw:bg-neutral-200]="sale.status === ISaleStatus.CANCELLED"
            [class.tw:text-neutral-800]="sale.status === ISaleStatus.CANCELLED">
            @if (sale.status === ISaleStatus.PAID && sale.invoiceStatus === InvoiceStatus.INVOICED) {
                {{'SALES_STATUS.paid' | translate}}
            } @else if (sale.invoiceStatus !== InvoiceStatus.INVOICED && sale.status !== ISaleStatus.CANCELLED) {
                {{'SALES_STATUS.uninvoiced' | translate}}
            } @else if (sale.status === ISaleStatus.PENDING_PAYMENT) {
                {{'SALES_STATUS.pending' | translate}}
            } @else if (sale.status === ISaleStatus.CANCELLED) {
                {{'SALES_STATUS.cancelled' | translate}}
            }
        </div>
    } @else {
        <div
            class="tw:border-1 tw:rounded-full tw:px-3 tw:py-1 tw:text-center tw:text-xs tw:font-semibold tw:uppercase tw:whitespace-nowrap"
            [class.tw:bg-success-100]="sale.status === ISaleStatus.PAID"
            [class.tw:text-success-800]="sale.status === ISaleStatus.PAID"
            [class.tw:bg-error-100]="sale.status === ISaleStatus.PENDING_PAYMENT || !sale.status"
            [class.tw:text-error-800]="sale.status === ISaleStatus.PENDING_PAYMENT || !sale.status"
            [class.tw:bg-neutral-200]="sale.status === ISaleStatus.CANCELLED"
            [class.tw:text-neutral-800]="sale.status === ISaleStatus.CANCELLED"
        >
            @if (sale.status === ISaleStatus.PAID) {
                {{ 'SALES_STATUS.paid' | translate }}
            } @else if (sale.status === ISaleStatus.PENDING_PAYMENT) {
                {{ 'SALES_STATUS.pending' | translate }}
            } @else if (sale.status === ISaleStatus.CANCELLED) {
                {{ 'SALES_STATUS.cancelled' | translate }}
            } @else {
                {{ 'SALES_STATUS.pending' | translate }}
            }
        </div>
    }

}
